import { trackTemplate } from '../../../utils/tracking';

/**
 * Ical Download Click
 * @param string text
 */
export function clickIcalLink(url) {
  return trackTemplate({
    event: 'genericEvent',
    data: {
      category: 'Downloads',
      action: 'Calendar File',
      label: url,
      value: '0',
    },
  });
}
